import React, { useState, useEffect } from 'react';

const AppointmentDetails = ({ initialValues = {}, onDataChange }) => {
    const formatDate = (dateString) => dateString ? new Date(dateString).toISOString().split('T')[0] : '';
    const formatTime = (timeString) => {
        if (!timeString) return '';
        const date = new Date(timeString);
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0'); 
        return `${hours}:${minutes}`;
    };
    const [customerName, setCustomerName] = useState(initialValues.customerName || '');
    const [customerPhone, setCustomerPhone] = useState(initialValues.customerPhone || '');
    const [appointmentDate, setAppointmentDate] = useState(formatDate(initialValues.appointmentDate));
    const [startTime, setStartTime] = useState(formatTime(initialValues.startTime));
    const [endTime, setEndTime] = useState(formatTime(initialValues.endTime));
    const [serviceName, setServiceName] = useState(initialValues.serviceId?.name || '');

    useEffect(() => {
        setCustomerName(initialValues.customerName || '');
        setCustomerPhone(initialValues.customerPhone || '');
        setAppointmentDate(formatDate(initialValues.appointmentDate));
        setStartTime(formatTime(initialValues.startTime));
        setEndTime(formatTime(initialValues.endTime));
        setServiceName(initialValues.serviceId?.name || '');
    }, [initialValues]);

    const handleCustomerNameChange = (e) => {
        setCustomerName(e.target.value);
        notifyParent();
    };

    const handleCustomerPhoneChange = (e) => {
        setCustomerPhone(e.target.value);
        notifyParent();
    };

    const handleAppointmentDateChange = (e) => {
        setAppointmentDate(e.target.value);
        notifyParent();
    };

    const handleStartTimeChange = (e) => {
        setStartTime(e.target.value);
        notifyParent();
    };

    const handleEndTimeChange = (e) => {
        setEndTime(e.target.value);
        notifyParent();
    };

    const notifyParent = () => {
        onDataChange({
            customerName,
            customerPhone,
            appointmentDate,
            startTime,
            endTime,
            serviceId: { name: serviceName },
        });
    };

    return (
        <div>
            <h3>Appointment Details</h3>
            <input
                type="text"
                placeholder="Customer Name"
                value={customerName}
                onChange={handleCustomerNameChange}
            />
            <input
                type="tel"
                placeholder="Customer Phone"
                value={customerPhone}
                onChange={handleCustomerPhoneChange}
            />
            <input
                type="date"
                placeholder="Appointment Date"
                value={appointmentDate}
                onChange={handleAppointmentDateChange}
            />

            <h3>Start Time</h3>
            <input
                type="time"
                placeholder="Start Time"
                value={startTime}
                onChange={handleStartTimeChange}
            />

            <h3>End Time</h3>
            <input
                type="time"
                placeholder="End Time"
                value={endTime}
                onChange={handleEndTimeChange}
            />

            <p>Service: {serviceName}</p>
        </div>
    );
};

export default AppointmentDetails;
